
define('text!pages/help/help_page_content_template.html',[],function () { return '<h1>Miten käytän tätä sovellusta?</h1>\r\n<p>Klikkaa alla olevaa linkkiä lukeaksesi sovelluksen ohjekirjan.</p>\r\n<p><a href="/files/Kesko_Retailer_GUI_user guide_FI_16032022.pdf" target="_blank">Sovelluksen ohjekirja</a></p>\r\n';});

